import EnrollmentService from "../services/enrollment-service";


export default class {
  static #storageKey = 'enrollments_list';

  static async update() {
    let response = await EnrollmentService.actives();
    console.debug({ response })
    sessionStorage.setItem(this.#storageKey, this.formatResponse(response));
    document.body.dispatchEvent(new Event('enrollment-storage-updated'));
  }

  static formatResponse(response) {
    return JSON.stringify(response.map((i) => { return { id: i.id, text: i.name.toUpperCase() } }));
  }

  static async get() {
    let value = sessionStorage.getItem(this.#storageKey);

    if (!value) {
      await this.update();
      value = sessionStorage.getItem(this.#storageKey)
    }

    return JSON.parse(value || []);
  }
}